import React, { useState } from 'react';

import { CircularProgress, Dialog } from '@material-ui/core';
import { studentWorkMasteryAndGradeBulkUpdate } from 'sdk';

import StudentWorkDialogEdit from 'pages/Teachers/ClassroomInsights/components/StudentWorkDialogEdit';
import { GRADES_MAPPER } from 'pages/Teachers/ClassroomInsights/constants';
import { notifyError, notifySuccess } from 'utils/notifications';

import styles from './style.module.scss';

export const StudentBulkEditDialog = ({
  onClose,
  onEdit,
  selectedStudentIds,
  affectedStudentNames,
  onActionSuccess,
  objectiveValueType,
  sectionId
}) => {
  const [isUpdating, setIsUpdating] = useState();

  const initialMastery = '';
  const initialGrade = '';

  const currentOptions = GRADES_MAPPER[objectiveValueType] || [];

  const handleBulkUpdate = async ({ updatedData }) => {
    setIsUpdating(true);

    if (!selectedStudentIds) {
      notifyError('Please select Student Works before trying to edit.');
      return;
    }

    const payload = {
      student_ids: selectedStudentIds,
      mastery_level: '',
      grade: ''
    };

    if (updatedData.overallMastery !== '') {
      payload.mastery_level = updatedData.overallMastery;
    }

    if (updatedData.grade !== '') {
      payload.grade = updatedData.grade;
    }

    if (Object.keys(payload).length === 0) {
      notifyError('No changes detected to apply.');
      setIsUpdating(false);
      return;
    }

    const { success } = await studentWorkMasteryAndGradeBulkUpdate({
      data: payload
    });

    if (success) {
      notifySuccess('Student works succesfully updated!');
      onActionSuccess();
    } else {
      notifyError('Failed to edit student works. Please try again.');
    }

    setIsUpdating(false);
    onClose();
    onEdit();
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      {isUpdating ? (
        <div className={styles.loadingContainer}>
          <CircularProgress />
        </div>
      ) : (
        <StudentWorkDialogEdit
          initialMastery={initialMastery}
          initialGrade={initialGrade}
          objectiveValueType={objectiveValueType}
          currentOptions={currentOptions}
          sectionId={sectionId}
          onConfirm={handleBulkUpdate}
          setIsEdit={onClose}
          affectedStudentNames={affectedStudentNames}
        />
      )}
    </Dialog>
  );
};

export default StudentBulkEditDialog;
